import { MetricView } from '@nemuru-eng/js-api-client';

import { MetricFilter } from './Filter/MetricFilter';

export class QueryBuilder {
  constructor(public readonly filters: MetricFilter<unknown>[]) {}

  public metricFilter<T extends MetricFilter<unknown>>(filter: T): T | undefined {
    return this.filters.find((currentFilter) => filter.field === currentFilter.field) as T;
  }

  public needsRequest(queryBuilder: QueryBuilder): boolean {
    return this.filters.some((filter) => filter.needsRequest(queryBuilder));
  }

  public merge(queryBuilder?: QueryBuilder): this {
    if (!queryBuilder) return this;
    const newFilters = this.filters.map((filter) => filter.merge(queryBuilder.metricFilter(filter)));
    return new QueryBuilder(newFilters) as this;
  }

  public createQuery(): string {
    return this.filters
      .filter((filter) => filter.values)
      .map((filter, index) => {
        return `filters[${index}][field]=${filter.field}&filters[${index}][operator]=${
          filter.operator
        }&filters[${index}][value]=${filter.value()}`;
      })
      .join('&');
  }

  public filterMetrics<K extends MetricView>(metricViews: K[] | undefined): K[] | undefined {
    if (!metricViews) return;
    return this.filters.reduce((cum, filter) => {
      const filteredMetrics = filter.filterMetrics(cum);
      return filteredMetrics;
    }, metricViews);
  }
}
